import {post, downFile} from './http'
const baseUrl = '/api/admin/mktools/agb'

// 商品分类列表
export const getMaterialCategoryList = v => post(`${baseUrl}/getMaterialCategoryList`, v.data, v.success, v.error)

// 保存、编辑商品分类
export const saveOrUpdateMaterialCategory = v => post(`${baseUrl}/saveOrUpdateMaterialCategory`, v.data, v.success, v.error)

// 获取商品分类详情
export const getMaterialCategoryInfo = v => post(`${baseUrl}/getMaterialCategoryInfo`, v.data, v.success, v.error)

// 删除单个商品分类
export const updateMaterialCategoryByStatus = v => post(`${baseUrl}/updateMaterialCategoryByStatus`, v.data, v.success, v.error)

// 新增商品素材
export const saveOrUpdateMaterials = v => post(`${baseUrl}/saveOrUpdateMaterials`, v.data, v.success, v.error)

// 删除、暂停、恢复商品素材
export const deleteStarsockpuppet = v => post(`${baseUrl}/deleteStarsockpuppet`, v.data, v.success, v.error)

// 商品素材列表
export const getMaterialsList = v => post(`${baseUrl}/getMaterialsList`, v.data, v.success, v.error)
export const searchMaterialList = v => post(`${baseUrl}/searchMaterialList`, v.data, v.success, v.error)

// 批量导入商品查询素材列表（不分页）
export const searchMaterials = v => post(`${baseUrl}/searchMaterials`, v.data, v.success, v.error)

// 批量导入商品素材
export const batchProductInfo = v => post(`${baseUrl}/batchProductInfo`, v.data, v.success, v.error)

// 商品分类列表 不分页
export const getMaterialCategory = v => post(`${baseUrl}/getMaterialCategory`, v.data, v.success, v.error)

// 获取商品素材详情
export const getMaterialsInfo = v => post(`${baseUrl}/getMaterialsInfo`, v.data, v.success, v.error)

// 获取群分组列表
export const getAgbCommGroupSimpleList = v => post(`${baseUrl}/getAgbCommGroupSimpleList`, v.data, v.success, v.error)

// 搜索群分组列表
export const getCommGroupList = v => post(`${baseUrl}/getCommGroupList`, v.data, v.success, v.error)

// 新增保存群分组
export const saveOrUpdateCommGroup = v => post(`${baseUrl}/saveOrUpdateCommGroup`, v.data, v.success, v.error)

// 获取群分组详情
export const getCommGroupInfo = v => post(`${baseUrl}/getCommGroupInfo`, v.data, v.success, v.error)

// 删除单一群分组
export const updateCommGroupByStatus = v => post(`${baseUrl}/updateCommGroupByStatus`, v.data, v.success, v.error)

// 核销员
// 获取核销员列表
export const getVerifierList = v => post(`${baseUrl}/getVerifierList`, v.data, v.success, v.error)

// 获取 可以绑定的 核销员列表
export const searchVerifierInfo = v => post(`${baseUrl}/searchVerifierInfo`, v.data, v.success, v.error)

// 新增核销员
export const saveVerifier = v => post(`${baseUrl}/saveVerifier`, v.data, v.success, v.error)

// 删除核销员
export const deleteVerifier = v => post(`${baseUrl}/deleteVerifier`, v.data, v.success, v.error)

// 社群拼购
// 获取社群列表
export const getAssociationsList = v => post(`${baseUrl}/getAssociationsList`, v.data, v.success, v.error)

// 获取社群分组列表
export const searchAssociationList = v => post(`${baseUrl}/searchAssociationList`, v.data, v.success, v.error)

// 新增社群
export const saveOrUpdateAssociations = v => post(`${baseUrl}/saveOrUpdateAssociations`, v.data, v.success, v.error)

// 获取社群详情
export const getAssociationsInfo = v => post(`${baseUrl}/getAssociationsInfo`, v.data, v.success, v.error)

// 删除社群
export const updateAssociationsByStatus = v => post(`${baseUrl}/updateAssociationsByStatus`, v.data, v.success, v.error)

// 分享社群
export const shareAssociations = v => post(`${baseUrl}/shareAssociations`, v.data, v.success, v.error)

// 复制社群
export const saveCopyAss = v => post(`${baseUrl}/saveCopyAss`, v.data, v.success, v.error)


// 获取活动下任务列表
// export const getEventTaskInfoList = v => post(`/api/admin/mktools/agb/getEventTaskInfoList`, v.data, v.success, v.error)
export const getEventTaskInfoList = v => post(`${baseUrl}/getEventTaskInfoList`, v.data, v.success, v.error)

// 新增、编辑商品
export const saveOrUpdateProductInfo = v => post(`${baseUrl}/saveOrUpdateProductInfo`, v.data, v.success, v.error)

// 活动增加/修改
export const saveOrUpdateEventInfo = v => post(`${baseUrl}/saveOrUpdateEventInfo`, v.data, v.success, v.error)
// 活动列表
export const getEventInfoList = v => post(`${baseUrl}/getEventInfoList`, v.data, v.success, v.error)

// 活动状态修改
export const updateEventByStatus = v => post(`${baseUrl}/updateEventByStatus`, v.data, v.success, v.error)

// 复制活动
export const saveCopyEvent = v => post(`${baseUrl}/saveCopyEvent`, v.data, v.success, v.error)

// 活动详情
export const getEventDetail = v => post(`${baseUrl}/getEventDetail`, v.data, v.success, v.error)


// 订单列表
export const getEventOrderList = v => post(`${baseUrl}/getEventOrderList`, v.data, v.success, v.error)
// 导出订单
export const getEventOrderExportInfo = v => downFile(`${baseUrl}/getEventOrderExportInfo`, v.data, v.success, v.error)
// 订单详情
export const getEventOrderInfo = v => post(`${baseUrl}/getEventOrderInfo`, v.data, v.success, v.error)

// 查询单个活动详情
export const getSimpleEventDetail = v => post(`${baseUrl}/getSimpleEventDetail`, v.data, v.success, v.error)
// 暂停或恢复活动任务
export const suspendedTask = v => post(`${baseUrl}/updateEventTaskInfoByStatus`, v.data, v.success, v.error)
// 活动商品列表
export const getEventProductList = v => post(`${baseUrl}/getEventProductList`, v.data, v.success, v.error)
// 停售或恢复商品
export const updateProductByStatus = v => post(`${baseUrl}/updateProductByStatus`, v.data, v.success, v.error)
// 单个商品详情
export const getProductInfo = v => post(`${baseUrl}/getProductInfo`, v.data, v.success, v.error)

// 查询社群用户列表
export const getUserInfoList = v => post(`${baseUrl}/getUserInfoList`, v.data, v.success, v.error)
// 查询社群用户详情
export const getUserInfo = v => post(`${baseUrl}/getUserInfo`, v.data, v.success, v.error)

// 查询用户详情下订单列表
export const getUserEventOrderList = v => post(`${baseUrl}/getUserEventOrderList`, v.data, v.success, v.error)
// 查询用户详情下邀请用户列表
export const getUserInviteList = v => post(`${baseUrl}/getUserInviteList`, v.data, v.success, v.error)

// 订单核销已核销订单列表
export const getCheckEventOrder = v => post(`${baseUrl}/getCheckEventOrder`, v.data, v.success, v.error)
// 根据核销条形码查询核销订单详情
export const getOrderInfoByLineCode = v => post(`${baseUrl}/getOrderInfoByLineCode`, v.data, v.success, v.error)
// 确认核销
export const updateEventOrderByCheck = v => post(`${baseUrl}/updateEventOrderByCheck`, v.data, v.success, v.error)

// 运营管理相关
// 用户分析列表
export const getAgbAnalysisdata = v => post(`${baseUrl}/getAgbAnalysisdata`, v.data, v.success, v.error)
// 社群顶部基本数据
export const getAgbBasicdata = v => post(`${baseUrl}/getAgbBasicdata`, v.data, v.success, v.error)
// 社群分析折线图
export const getAgbBasiclinechartdata = v => post(`${baseUrl}/getAgbBasiclinechartdata`, v.data, v.success, v.error)
// 活动分析
export const getAgbEventInfodata = v => post(`${baseUrl}/getAgbEventInfodata`, v.data, v.success, v.error)
// 活动分析管理导出
export const exportAgbEventInfodata = v => downFile(`${baseUrl}/exportAgbEventInfodata`, v.data, v.success, v.error)

// 任务列表手动生成任务
export const createAgbEventTaskInfo = v => post(`${baseUrl}/createAgbEventTaskInfo`, v.data, v.success, v.error)
// 任务列表手动生成任务
export const agbEventTaskSettlement = v => post(`${baseUrl}/agbEventTaskSettlement`, v.data, v.success, v.error)